const A_pieBG = [
  "M0,-0l14.03,400l-14.098,0l0,-400Z",
  "M0,-0l400,-0l-0.246,14.098l-399.816,-14.03Z",
  "M0,-0l399.821,13.894l-0.738,14.081l-399.083,-27.975Z",
  "M0,-0l399.092,27.839l-1.229,14.046l-397.863,-41.885Z",
  "M0,-0l397.877,41.75l-1.718,13.995l-396.159,-55.745Z",
  "M0,-0l396.178,55.61l-2.206,13.927l-393.972,-69.537Z",
  "M0,-0l393.996,69.403l-2.691,13.841l-391.305,-83.244Z",
  "M0,-0l391.334,83.111l-3.172,13.739l-388.162,-96.85Z",
  "M0,-0l388.195,96.718l-3.65,13.619l-384.545,-110.337Z",
  "M0,-0l384.583,110.207l-4.123,13.484l-380.46,-123.691Z",
  "M0,-0l380.502,123.561l-4.59,13.332l-375.912,-136.893Z",
  "M0,-0l375.958,136.765l-5.053,13.164l-370.905,-149.929Z",
  "M0,-0l370.956,149.803l-5.509,12.979l-365.447,-162.782Z",
  "M0,-0l365.502,162.658l-5.959,12.779l-359.543,-175.437Z",
  "M0,-0l359.603,175.314l-6.401,12.564l-353.202,-187.878Z",
  "M0,-0l353.266,187.758l-6.836,12.332l-346.43,-200.09Z",
  "M0,-0l346.498,199.972l-7.262,12.086l-339.236,-212.058Z",
  "M0,-0l339.308,211.943l-7.68,11.825l-331.628,-223.768Z",
  "M0,-0l331.704,223.655l-8.087,11.55l-323.617,-235.205Z",
  "M0,-0l323.697,235.096l-8.486,11.26l-315.211,-246.356Z",
  "M0,-0l315.295,246.249l-8.874,10.958l-306.421,-257.207Z",
  "M0,-0l306.509,257.103l-9.251,10.641l-297.258,-267.744Z",
  "M0,-0l297.349,267.643l-9.616,10.312l-287.733,-277.955Z",
  "M0,-0l287.828,277.857l-9.971,9.971l-277.857,-287.828Z",
  "M0,-0l277.955,287.733l-10.312,9.616l-267.643,-297.349Z",
  "M0,-0l267.744,297.258l-10.641,9.251l-257.103,-306.509Z",
  "M0,-0l257.207,306.422l-10.958,8.873l-246.249,-315.295Z",
  "M0,-0l246.356,315.211l-11.261,8.486l-235.095,-323.697Z",
  "M0,-0l235.205,323.617l-11.55,8.087l-223.655,-331.704Z",
  "M0,-0l223.768,331.628l-11.825,7.68l-211.943,-339.308Z",
  "M0,-0l212.058,339.236l-12.086,7.262l-199.972,-346.498Z",
  "M0,-0l200.09,346.43l-12.332,6.836l-187.758,-353.266Z",
  "M0,-0l187.878,353.202l-12.564,6.401l-175.314,-359.603Z",
  "M0,-0l175.437,359.544l-12.779,5.958l-162.658,-365.502Z",
  "M0,-0l162.782,365.447l-12.979,5.509l-149.803,-370.956Z",
  "M0,-0l149.929,370.906l-13.164,5.053l-136.765,-375.959Z",
  "M0,-0l136.893,375.912l-13.332,4.591l-123.561,-380.503Z",
  "M0,-0l123.69,380.461l-13.483,4.122l-110.207,-384.583Z",
  "M0,-0l110.337,384.546l-13.619,3.649l-96.718,-388.195Z",
  "M0,-0l96.85,388.162l-13.739,3.172l-83.111,-391.334Z",
  "M0,-0l83.244,391.306l-13.841,2.69l-69.403,-393.996Z",
  "M0,-0l69.537,393.972l-13.927,2.206l-55.61,-396.178Z",
  "M0,-0l55.745,396.159l-13.995,1.719l-41.75,-397.878Z",
  "M0,-0l41.885,397.863l-14.046,1.229l-27.839,-399.092Z",
  "M0,-0l27.975,400l-14.081,0.738l-13.894,-400Z",
];
const A_pieFG = [
  "M400,400l-14.03,-400l14.098,-0.246l-0,400Z",
  "M400,400l-400,0l0.246,-14.098l399.816,14.03Z",
  "M400,400l-399.821,-13.894l0.738,-14.081l399.083,27.975Z",
  "M400,400l-399.092,-27.839l1.229,-14.046l397.863,41.885Z",
  "M400,400l-397.878,-41.75l1.719,-13.995l396.159,55.745Z",
  "M400,400l-396.178,-55.611l2.206,-13.926l393.972,69.537Z",
  "M400,400l-393.996,-69.403l2.69,-13.841l391.306,83.244Z",
  "M400,400l-391.334,-83.111l3.172,-13.739l388.162,96.85Z",
  "M400,400l-388.195,-96.718l3.649,-13.619l384.546,110.337Z",
  "M400,400l-384.583,-110.207l4.122,-13.484l380.461,123.691Z",
  "M400,400l-380.503,-123.561l4.591,-13.332l375.912,136.893Z",
  "M400,400l-375.959,-136.765l5.053,-13.164l370.906,149.929Z",
  "M400,400l-370.957,-149.803l5.51,-12.979l365.447,162.782Z",
  "M400,400l-365.503,-162.658l5.959,-12.779l359.544,175.437Z",
  "M400,400l-359.603,-175.315l6.401,-12.563l353.202,187.878Z",
  "M400,400l-353.266,-187.758l6.836,-12.332l346.43,200.09Z",
  "M400,400l-346.498,-199.972l7.262,-12.086l339.236,212.058Z",
  "M400,400l-339.308,-211.943l7.679,-11.825l331.629,223.768Z",
  "M400,400l-331.705,-223.656l8.088,-11.55l323.617,235.206Z",
  "M400,400l-323.697,-235.096l8.486,-11.26l315.211,246.356Z",
  "M400,400l-315.295,-246.249l8.873,-10.958l306.422,257.207Z",
  "M400,400l-306.509,-257.103l9.25,-10.641l297.259,267.744Z",
  "M400,400l-297.35,-267.643l9.617,-10.312l287.733,277.955Z",
  "M400,400l-287.828,-277.858l9.97,-9.97l277.858,287.828Z",
  "M400,400l-277.955,-287.733l10.312,-9.617l267.643,297.35Z",
  "M400,400l-267.744,-297.259l10.641,-9.25l257.103,306.509Z",
  "M400,400l-257.207,-306.422l10.958,-8.873l246.249,315.295Z",
  "M400,400l-246.356,-315.211l11.26,-8.486l235.096,323.697Z",
  "M400,400l-235.206,-323.617l11.55,-8.088l223.656,331.705Z",
  "M400,400l-223.768,-331.629l11.825,-7.679l211.943,339.308Z",
  "M400,400l-212.058,-339.236l12.086,-7.262l199.972,346.498Z",
  "M400,400l-200.09,-346.43l12.332,-6.836l187.758,353.266Z",
  "M400,400l-187.878,-353.202l12.563,-6.401l175.315,359.603Z",
  "M400,400l-175.437,-359.544l12.779,-5.959l162.658,365.503Z",
  "M400,400l-162.782,-365.447l12.979,-5.51l149.803,370.957Z",
  "M400,400l-149.929,-370.906l13.164,-5.053l136.765,375.959Z",
  "M400,400l-136.893,-375.912l13.332,-4.591l123.561,380.503Z",
  "M400,400l-123.691,-380.461l13.484,-4.122l110.207,384.583Z",
  "M400,400l-110.337,-384.546l13.619,-3.649l96.718,388.195Z",
  "M400,400l-96.85,-388.162l13.739,-3.172l83.111,391.334Z",
  "M400,400l-83.244,-391.306l13.841,-2.69l69.403,393.996Z",
  "M400,400l-69.537,-393.972l13.926,-2.206l55.611,396.178Z",
  "M400,400l-55.745,-396.159l13.995,-1.719l41.75,397.878Z",
  "M400,400l-41.885,-397.863l14.046,-1.229l27.839,399.092Z",
  "M400,400l-27.975,-400l14.081,-0.738l13.894,400Z",
];

const B_pieBG = [
  "M400,-0l-400,14.03l-0.246,-14.098l400,0Z",
  "M400,-0l0,400l-14.098,-0.246l14.03,-399.816Z",
  "M400,-0l-13.894,399.821l-14.081,-0.738l27.975,-399.083Z",
  "M400,-0l-27.839,399.092l-14.047,-1.229l41.886,-397.863Z",
  "M400,-0l-41.75,397.878l-13.995,-1.719l55.745,-396.159Z",
  "M400,-0l-55.611,396.178l-13.926,-2.206l69.537,-393.972Z",
  "M400,-0l-69.403,393.996l-13.841,-2.69l83.244,-391.306Z",
  "M400,-0l-83.111,391.334l-13.739,-3.172l96.85,-388.162Z",
  "M400,-0l-96.718,388.195l-13.619,-3.649l110.337,-384.546Z",
  "M400,-0l-110.207,384.583l-13.484,-4.122l123.691,-380.461Z",
  "M400,-0l-123.561,380.503l-13.332,-4.591l136.893,-375.912Z",
  "M400,-0l-136.765,375.959l-13.164,-5.053l149.929,-370.906Z",
  "M400,-0l-149.803,370.956l-12.979,-5.509l162.782,-365.447Z",
  "M400,-0l-162.658,365.502l-12.779,-5.958l175.437,-359.544Z",
  "M400,-0l-175.315,359.603l-12.563,-6.401l187.878,-353.202Z",
  "M400,-0l-187.758,353.266l-12.332,-6.836l200.09,-346.43Z",
  "M400,-0l-199.972,346.498l-12.086,-7.262l212.058,-339.236Z",
  "M400,-0l-211.943,339.308l-11.825,-7.68l223.768,-331.628Z",
  "M400,-0l-223.656,331.704l-11.55,-8.087l235.206,-323.617Z",
  "M400,-0l-235.096,323.697l-11.26,-8.486l246.356,-315.211Z",
  "M400,-0l-246.249,315.295l-10.958,-8.873l257.207,-306.422Z",
  "M400,-0l-257.103,306.509l-10.641,-9.251l267.744,-297.258Z",
  "M400,-0l-267.643,297.349l-10.312,-9.616l277.955,-287.733Z",
  "M400,-0l-277.858,287.828l-9.97,-9.971l287.828,-277.857Z",
  "M400,-0l-287.733,277.955l-9.617,-10.312l297.35,-267.643Z",
  "M400,-0l-297.259,267.744l-9.25,-10.641l306.509,-257.103Z",
  "M400,-0l-306.422,257.207l-8.873,-10.958l315.295,-246.249Z",
  "M400,-0l-315.211,246.356l-8.486,-11.26l323.697,-235.096Z",
  "M400,-0l-323.617,235.205l-8.088,-11.55l331.705,-223.655Z",
  "M400,-0l-331.629,223.768l-7.679,-11.825l339.308,-211.943Z",
  "M400,-0l-339.236,212.058l-7.262,-12.086l346.498,-199.972Z",
  "M400,-0l-346.43,200.09l-6.836,-12.332l353.266,-187.758Z",
  "M400,-0l-353.202,187.878l-6.401,-12.564l359.603,-175.314Z",
  "M400,-0l-359.544,175.437l-5.959,-12.779l365.503,-162.658Z",
  "M400,-0l-365.447,162.782l-5.51,-12.979l370.957,-149.803Z",
  "M400,-0l-370.906,149.929l-5.053,-13.164l375.959,-136.765Z",
  "M400,-0l-375.912,136.893l-4.591,-13.332l380.503,-123.561Z",
  "M400,-0l-380.461,123.691l-4.122,-13.484l384.583,-110.207Z",
  "M400,-0l-384.546,110.337l-3.649,-13.619l388.195,-96.718Z",
  "M400,-0l-388.162,96.85l-3.172,-13.739l391.334,-83.111Z",
  "M400,-0l-391.306,83.244l-2.69,-13.841l393.996,-69.403Z",
  "M400,-0l-393.973,69.537l-2.205,-13.927l396.178,-55.61Z",
  "M400,-0l-396.159,55.745l-1.719,-13.995l397.878,-41.75Z",
  "M400,-0l-397.863,41.885l-1.229,-14.046l399.092,-27.839Z",
  "M400,-0l-400,27.975l-0.738,-14.081l399.821,-13.894Z",
];
const B_pieFG = [
  "M-0,400l-0,-400l14.098,0.246l-14.03,400Z",
  "M-0,400l13.894,-399.821l14.081,0.738l-27.975,399.083Z",
  "M-0,400l27.839,-399.092l14.046,1.229l-41.885,397.863Z",
  "M-0,400l41.75,-397.878l13.995,1.719l-55.745,396.159Z",
  "M-0,400l55.61,-396.178l13.927,2.206l-69.537,393.972Z",
  "M-0,400l69.403,-393.996l13.841,2.69l-83.244,391.306Z",
  "M-0,400l83.111,-391.334l13.739,3.172l-96.85,388.162Z",
  "M-0,400l96.718,-388.195l13.619,3.649l-110.337,384.546Z",
  "M-0,400l110.207,-384.583l13.484,4.122l-123.691,380.461Z",
  "M-0,400l123.561,-380.503l13.332,4.591l-136.893,375.912Z",
  "M-0,400l136.765,-375.959l13.164,5.053l-149.929,370.906Z",
  "M-0,400l149.803,-370.956l12.979,5.509l-162.782,365.447Z",
  "M-0,400l162.658,-365.502l12.779,5.958l-175.437,359.544Z",
  "M-0,400l175.314,-359.603l12.564,6.401l-187.878,353.202Z",
  "M-0,400l187.758,-353.266l12.332,6.836l-200.09,346.43Z",
  "M-0,400l199.972,-346.498l12.086,7.262l-212.058,339.236Z",
  "M-0,400l211.943,-339.308l11.825,7.68l-223.768,331.628Z",
  "M-0,400l223.655,-331.704l11.55,8.087l-235.205,323.617Z",
  "M-0,400l235.096,-323.697l11.26,8.486l-246.356,315.211Z",
  "M-0,400l246.249,-315.295l10.958,8.873l-257.207,306.422Z",
  "M-0,400l257.103,-306.509l10.641,9.251l-267.744,297.258Z",
  "M-0,400l267.643,-297.349l10.312,9.616l-277.955,287.733Z",
  "M-0,400l277.857,-287.828l9.971,9.971l-287.828,277.857Z",
  "M-0,400l287.733,-277.955l9.616,10.312l-297.349,267.643Z",
  "M-0,400l297.258,-267.744l9.251,10.641l-306.509,257.103Z",
  "M-0,400l306.422,-257.207l8.873,10.958l-315.295,246.249Z",
  "M-0,400l315.211,-246.356l8.486,11.26l-323.697,235.096Z",
  "M-0,400l323.617,-235.205l8.087,11.55l-331.704,223.655Z",
  "M-0,400l331.628,-223.768l7.68,11.825l-339.308,211.943Z",
  "M-0,400l339.236,-212.058l7.262,12.086l-346.498,199.972Z",
  "M-0,400l346.43,-200.09l6.836,12.332l-353.266,187.758Z",
  "M-0,400l353.202,-187.878l6.401,12.564l-359.603,175.314Z",
  "M-0,400l359.544,-175.437l5.958,12.779l-365.502,162.658Z",
  "M-0,400l365.447,-162.782l5.509,12.979l-370.956,149.803Z",
  "M-0,400l370.906,-149.929l5.053,13.164l-375.959,136.765Z",
  "M-0,400l375.912,-136.893l4.591,13.332l-380.503,123.561Z",
  "M-0,400l380.461,-123.691l4.122,13.484l-384.583,110.207Z",
  "M-0,400l384.546,-110.337l3.649,13.619l-388.195,96.718Z",
  "M-0,400l388.162,-96.85l3.172,13.739l-391.334,83.111Z",
  "M-0,400l391.306,-83.244l2.69,13.841l-393.996,69.403Z",
  "M-0,400l393.972,-69.537l2.206,13.927l-396.178,55.61Z",
  "M-0,400l396.159,-55.745l1.719,13.995l-397.878,41.75Z",
  "M-0,400l397.863,-41.885l1.229,14.046l-399.092,27.839Z",
  "M-0,400l399.083,-27.975l0.738,14.081l-399.821,13.894Z",
  "M-0,400l400,-14.03l0.246,14.098l-400,-0Z",
];

const C_pieBG = [
  "M-0,400l400,-14.03l0.246,14.098l-400,-0Z",
  "M-0,400l-0,-400l14.098,0.246l-14.03,399.816Z",
  "M-0,400l13.894,-399.821l14.081,0.738l-27.975,399.083Z",
  "M-0,400l27.839,-399.092l14.046,1.229l-41.885,397.863Z",
  "M-0,400l41.75,-397.878l13.995,1.719l-55.745,396.159Z",
  "M-0,400l55.61,-396.178l13.927,2.206l-69.537,393.972Z",
  "M-0,400l69.403,-393.996l13.841,2.69l-83.244,391.306Z",
  "M-0,400l83.111,-391.334l13.739,3.172l-96.85,388.162Z",
  "M-0,400l96.718,-388.195l13.619,3.649l-110.337,384.546Z",
  "M-0,400l110.207,-384.583l13.484,4.122l-123.691,380.461Z",
  "M-0,400l123.561,-380.503l13.332,4.591l-136.893,375.912Z",
  "M-0,400l136.765,-375.959l13.164,5.053l-149.929,370.906Z",
  "M-0,400l149.803,-370.956l12.979,5.509l-162.782,365.447Z",
  "M-0,400l162.658,-365.502l12.779,5.958l-175.437,359.544Z",
  "M-0,400l175.314,-359.603l12.564,6.401l-187.878,353.202Z",
  "M-0,400l187.758,-353.266l12.332,6.836l-200.09,346.43Z",
  "M-0,400l199.972,-346.498l12.086,7.262l-212.058,339.236Z",
  "M-0,400l211.943,-339.308l11.825,7.68l-223.768,331.628Z",
  "M-0,400l223.655,-331.704l11.55,8.087l-235.205,323.617Z",
  "M-0,400l235.096,-323.697l11.26,8.486l-246.356,315.211Z",
  "M-0,400l246.249,-315.295l10.958,8.873l-257.207,306.422Z",
  "M-0,400l257.103,-306.509l10.641,9.251l-267.744,297.258Z",
  "M-0,400l267.643,-297.349l10.312,9.616l-277.955,287.733Z",
  "M-0,400l277.857,-287.828l9.971,9.971l-287.828,277.857Z",
  "M-0,400l287.733,-277.955l9.616,10.312l-297.349,267.643Z",
  "M-0,400l297.258,-267.744l9.251,10.641l-306.509,257.103Z",
  "M-0,400l306.422,-257.207l8.873,10.958l-315.295,246.249Z",
  "M-0,400l315.211,-246.356l8.486,11.26l-323.697,235.096Z",
  "M-0,400l323.617,-235.205l8.087,11.55l-331.704,223.655Z",
  "M-0,400l331.628,-223.768l7.68,11.825l-339.308,211.943Z",
  "M-0,400l339.236,-212.058l7.262,12.086l-346.498,199.972Z",
  "M-0,400l346.43,-200.09l6.836,12.332l-353.266,187.758Z",
  "M-0,400l353.202,-187.878l6.401,12.564l-359.603,175.314Z",
  "M-0,400l359.544,-175.437l5.958,12.779l-365.502,162.658Z",
  "M-0,400l365.447,-162.782l5.509,12.979l-370.956,149.803Z",
  "M-0,400l370.906,-149.929l5.053,13.164l-375.959,136.765Z",
  "M-0,400l375.912,-136.893l4.591,13.332l-380.503,123.561Z",
  "M-0,400l380.461,-123.691l4.122,13.484l-384.583,110.207Z",
  "M-0,400l384.546,-110.337l3.649,13.619l-388.195,96.718Z",
  "M-0,400l388.162,-96.85l3.172,13.739l-391.334,83.111Z",
  "M-0,400l391.306,-83.244l2.69,13.841l-393.996,69.403Z",
  "M-0,400l393.972,-69.537l2.206,13.927l-396.178,55.61Z",
  "M-0,400l396.159,-55.745l1.719,13.995l-397.878,41.75Z",
  "M-0,400l397.863,-41.885l1.229,14.046l-399.092,27.839Z",
  "M-0,400l400,-27.975l0.738,14.081l-400,13.894Z",
];
const C_pieFG = [
  "M400,0l0,400l-14.098,-0.246l14.03,-400Z",
  "M400,0l-13.894,399.821l-14.081,-0.738l27.975,-399.083Z",
  "M400,0l-27.839,399.092l-14.046,-1.229l41.885,-397.863Z",
  "M400,0l-41.75,397.878l-13.995,-1.719l55.745,-396.159Z",
  "M400,0l-55.61,396.178l-13.927,-2.206l69.537,-393.972Z",
  "M400,0l-69.403,393.996l-13.841,-2.69l83.244,-391.306Z",
  "M400,0l-83.111,391.334l-13.739,-3.172l96.85,-388.162Z",
  "M400,0l-96.718,388.195l-13.619,-3.649l110.337,-384.546Z",
  "M400,0l-110.207,384.583l-13.484,-4.122l123.691,-380.461Z",
  "M400,0l-123.561,380.503l-13.332,-4.591l136.893,-375.912Z",
  "M400,0l-136.765,375.959l-13.164,-5.053l149.929,-370.906Z",
  "M400,0l-149.803,370.957l-12.979,-5.51l162.782,-365.447Z",
  "M400,0l-162.658,365.503l-12.779,-5.959l175.437,-359.544Z",
  "M400,0l-175.314,359.603l-12.564,-6.401l187.878,-353.202Z",
  "M400,0l-187.758,353.266l-12.332,-6.836l200.09,-346.43Z",
  "M400,0l-199.972,346.498l-12.086,-7.262l212.058,-339.236Z",
  "M400,0l-211.943,339.308l-11.825,-7.68l223.768,-331.628Z",
  "M400,0l-223.655,331.704l-11.55,-8.087l235.205,-323.617Z",
  "M400,0l-235.096,323.697l-11.26,-8.486l246.356,-315.211Z",
  "M400,0l-246.249,315.295l-10.958,-8.873l257.207,-306.422Z",
  "M400,0l-257.103,306.509l-10.641,-9.25l267.744,-297.259Z",
  "M400,0l-267.643,297.35l-10.312,-9.617l277.955,-287.733Z",
  "M400,0l-277.857,287.828l-9.971,-9.97l287.828,-277.858Z",
  "M400,0l-287.733,277.955l-9.616,-10.312l297.349,-267.643Z",
  "M400,0l-297.258,267.744l-9.251,-10.641l306.509,-257.103Z",
  "M400,0l-306.422,257.207l-8.873,-10.958l315.295,-246.249Z",
  "M400,0l-315.211,246.356l-8.486,-11.26l323.697,-235.096Z",
  "M400,0l-323.617,235.206l-8.087,-11.55l331.704,-223.656Z",
  "M400,0l-331.628,223.768l-7.68,-11.825l339.308,-211.943Z",
  "M400,0l-339.236,212.058l-7.262,-12.086l346.498,-199.972Z",
  "M400,0l-346.43,200.09l-6.836,-12.332l353.266,-187.758Z",
  "M400,0l-353.202,187.878l-6.401,-12.563l359.603,-175.315Z",
  "M400,0l-359.544,175.437l-5.958,-12.779l365.502,-162.658Z",
  "M400,0l-365.447,162.782l-5.509,-12.979l370.956,-149.803Z",
  "M400,0l-370.906,149.929l-5.053,-13.164l375.959,-136.765Z",
  "M400,0l-375.912,136.893l-4.591,-13.332l380.503,-123.561Z",
  "M400,0l-380.461,123.691l-4.122,-13.484l384.583,-110.207Z",
  "M400,0l-384.546,110.337l-3.649,-13.619l388.195,-96.718Z",
  "M400,0l-388.162,96.85l-3.172,-13.739l391.334,-83.111Z",
  "M400,0l-391.306,83.244l-2.69,-13.841l393.996,-69.403Z",
  "M400,0l-393.972,69.537l-2.206,-13.926l396.178,-55.611Z",
  "M400,0l-396.159,55.745l-1.719,-13.995l397.878,-41.75Z",
  "M400,0l-397.863,41.885l-1.229,-14.046l399.092,-27.839Z",
  "M400,0l-399.083,27.975l-0.738,-14.081l399.821,-13.894Z",
  "M400,0l-400,14.03l-0.246,-14.098l400,0Z",
];

const D_pieBG = [
  "M400,400l-14.03,-400l14.098,-0.246l-0,400Z",
  "M400,400l-400,0l0.246,-14.098l399.816,14.03Z",
  "M400,400l-399.821,-13.894l0.738,-14.081l399.083,27.975Z",
  "M400,400l-399.092,-27.839l1.229,-14.046l397.863,41.885Z",
  "M400,400l-397.878,-41.75l1.719,-13.995l396.159,55.745Z",
  "M400,400l-396.178,-55.611l2.206,-13.926l393.972,69.537Z",
  "M400,400l-393.996,-69.403l2.69,-13.841l391.306,83.244Z",
  "M400,400l-391.334,-83.111l3.172,-13.739l388.162,96.85Z",
  "M400,400l-388.195,-96.718l3.649,-13.619l384.546,110.337Z",
  "M400,400l-384.583,-110.207l4.122,-13.484l380.461,123.691Z",
  "M400,400l-380.503,-123.561l4.591,-13.332l375.912,136.893Z",
  "M400,400l-375.959,-136.765l5.053,-13.164l370.906,149.929Z",
  "M400,400l-370.957,-149.803l5.51,-12.979l365.447,162.782Z",
  "M400,400l-365.503,-162.658l5.959,-12.779l359.544,175.437Z",
  "M400,400l-359.603,-175.315l6.401,-12.563l353.202,187.878Z",
  "M400,400l-353.266,-187.758l6.836,-12.332l346.43,200.09Z",
  "M400,400l-346.498,-199.972l7.262,-12.086l339.236,212.058Z",
  "M400,400l-339.308,-211.943l7.68,-11.825l331.628,223.768Z",
  "M400,400l-331.704,-223.655l8.087,-11.551l323.617,235.206Z",
  "M400,400l-323.697,-235.096l8.486,-11.26l315.211,246.356Z",
  "M400,400l-315.295,-246.249l8.873,-10.958l306.422,257.207Z",
  "M400,400l-306.509,-257.103l9.25,-10.641l297.259,267.744Z",
  "M400,400l-297.35,-267.643l9.617,-10.312l287.733,277.955Z",
  "M400,400l-287.828,-277.858l9.97,-9.97l277.858,287.828Z",
  "M400,400l-277.955,-287.733l10.312,-9.616l267.643,297.349Z",
  "M400,400l-267.744,-297.259l10.641,-9.25l257.103,306.509Z",
  "M400,400l-257.207,-306.422l10.958,-8.873l246.249,315.295Z",
  "M400,400l-246.356,-315.211l11.26,-8.486l235.096,323.697Z",
  "M400,400l-235.206,-323.617l11.55,-8.087l223.656,331.704Z",
  "M400,400l-223.768,-331.628l11.825,-7.68l211.943,339.308Z",
  "M400,400l-212.058,-339.236l12.086,-7.262l199.972,346.498Z",
  "M400,400l-200.09,-346.43l12.332,-6.836l187.758,353.266Z",
  "M400,400l-187.878,-353.202l12.563,-6.401l175.315,359.603Z",
  "M400,400l-175.437,-359.544l12.779,-5.958l162.658,365.502Z",
  "M400,400l-162.782,-365.447l12.979,-5.51l149.803,370.957Z",
  "M400,400l-149.929,-370.906l13.164,-5.053l136.765,375.959Z",
  "M400,400l-136.893,-375.912l13.332,-4.591l123.561,380.503Z",
  "M400,400l-123.691,-380.461l13.484,-4.122l110.207,384.583Z",
  "M400,400l-110.337,-384.546l13.619,-3.649l96.718,388.195Z",
  "M400,400l-96.85,-388.162l13.739,-3.172l83.111,391.334Z",
  "M400,400l-83.244,-391.306l13.841,-2.69l69.403,393.996Z",
  "M400,400l-69.537,-393.972l13.926,-2.206l55.611,396.178Z",
  "M400,400l-55.745,-396.159l13.995,-1.719l41.75,397.878Z",
  "M400,400l-41.885,-397.863l14.046,-1.229l27.839,399.092Z",
  "M400,400l-27.975,-400l14.081,-0.738l13.894,400Z",
];
const D_pieFG = [
  "M-0,0l400,-0l-0,14.098l-400,-14.03Z",
  "M-0,0l399.821,13.894l-0.738,14.081l-399.083,-27.975Z",
  "M-0,0l399.092,27.839l-1.229,14.046l-397.863,-41.885Z",
  "M-0,0l397.878,41.75l-1.719,13.995l-396.159,-55.745Z",
  "M-0,0l396.178,55.61l-2.206,13.927l-393.972,-69.537Z",
  "M-0,0l393.996,69.403l-2.69,13.841l-391.306,-83.244Z",
  "M-0,0l391.334,83.111l-3.172,13.739l-388.162,-96.85Z",
  "M-0,0l388.195,96.718l-3.649,13.619l-384.546,-110.337Z",
  "M-0,0l384.583,110.207l-4.122,13.484l-380.461,-123.691Z",
  "M-0,0l380.503,123.561l-4.591,13.332l-375.912,-136.893Z",
  "M-0,0l375.959,136.765l-5.053,13.164l-370.906,-149.929Z",
  "M-0,0l370.956,149.803l-5.509,12.979l-365.447,-162.782Z",
  "M-0,0l365.502,162.658l-5.958,12.779l-359.544,-175.437Z",
  "M-0,0l359.603,175.314l-6.401,12.564l-353.202,-187.878Z",
  "M-0,0l353.266,187.758l-6.836,12.332l-346.43,-200.09Z",
  "M-0,0l346.498,199.972l-7.262,12.086l-339.236,-212.058Z",
  "M-0,0l339.308,211.943l-7.68,11.825l-331.628,-223.768Z",
  "M-0,0l331.704,223.655l-8.087,11.55l-323.617,-235.205Z",
  "M-0,0l323.697,235.096l-8.486,11.26l-315.211,-246.356Z",
  "M-0,0l315.295,246.249l-8.873,10.958l-306.422,-257.207Z",
  "M-0,0l306.509,257.103l-9.251,10.641l-297.258,-267.744Z",
  "M-0,0l297.349,267.643l-9.616,10.312l-287.733,-277.955Z",
  "M-0,0l287.828,277.857l-9.971,9.971l-277.857,-287.828Z",
  "M-0,0l277.955,287.733l-10.312,9.616l-267.643,-297.349Z",
  "M-0,0l267.744,297.258l-10.641,9.251l-257.103,-306.509Z",
  "M-0,0l257.207,306.422l-10.958,8.873l-246.249,-315.295Z",
  "M-0,0l246.356,315.211l-11.26,8.486l-235.096,-323.697Z",
  "M-0,0l235.205,323.617l-11.55,8.087l-223.655,-331.704Z",
  "M-0,0l223.768,331.628l-11.825,7.68l-211.943,-339.308Z",
  "M-0,0l212.058,339.236l-12.086,7.262l-199.972,-346.498Z",
  "M-0,0l200.09,346.43l-12.332,6.836l-187.758,-353.266Z",
  "M-0,0l187.878,353.202l-12.564,6.401l-175.314,-359.603Z",
  "M-0,0l175.437,359.544l-12.779,5.958l-162.658,-365.502Z",
  "M-0,0l162.782,365.447l-12.979,5.509l-149.803,-370.956Z",
  "M-0,0l149.929,370.906l-13.164,5.053l-136.765,-375.959Z",
  "M-0,0l136.893,375.912l-13.332,4.591l-123.561,-380.503Z",
  "M-0,0l123.691,380.461l-13.484,4.122l-110.207,-384.583Z",
  "M-0,0l110.337,384.546l-13.619,3.649l-96.718,-388.195Z",
  "M-0,0l96.85,388.162l-13.739,3.172l-83.111,-391.334Z",
  "M-0,0l83.244,391.306l-13.841,2.69l-69.403,-393.996Z",
  "M-0,0l69.537,393.972l-13.927,2.206l-55.61,-396.178Z",
  "M-0,0l55.745,396.159l-13.995,1.719l-41.75,-397.878Z",
  "M-0,0l41.885,397.863l-14.046,1.229l-27.839,-399.092Z",
  "M-0,0l27.975,399.083l-14.081,0.738l-13.894,-400Z",
  "M-0,0l14.03,400l-14.098,0l0,-400Z",
];

const angles = [
  { BG: A_pieBG, FG: A_pieFG },
  { BG: B_pieBG, FG: B_pieFG },
  { BG: C_pieBG, FG: C_pieFG },
  { BG: D_pieBG, FG: D_pieFG },
];

export default angles;
